import React, { Component } from 'react';
import { Grid,Row,Col,Image,FormGroup,FormControl } from 'react-bootstrap';
import './Transactions.css';
import { API_ROOT } from '../../config.js';
import spinner from '../Header/Spinner-1s-150px.svg';

class Transactions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transId: this.props.match.params.transid,
      transDetails: '',
      orderDetails: '',
      isTransLoading: true,
      isOrderLoading: true
    }
  }

  componentDidMount() {
    fetch(`${API_ROOT}/transactions/${this.state.transId}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    })
    .then (response => {
      if (response.ok === true) {
        return response.json()
      }
    })
    .then ( data => {
      const trans = data.transactions
      const orders = data.orders
      var transDetails =
         (
           <React.Fragment>
           <Row>
             <Col xs={3} sm={3} md={3} lg={3}>Reference No.</Col>
             <Col xs={9} sm={9} md={9} lg={9}>: {trans.reference_number} </Col>
           </Row>
          <Row>
            <Col xs={3} sm={3} md={3} lg={3}>Amount</Col>
            <Col xs={9} sm={9} md={9} lg={9}>: {trans.currency}{trans.amount} </Col>
          </Row>
          <Row>
            <Col xs={3} sm={3} md={3} lg={3}>Buyer Name</Col>
            <Col xs={9} sm={9} md={9} lg={9}>: {trans.payor_name} </Col>
          </Row>
          <Row>
            <Col xs={3} sm={3} md={3} lg={3}>Buyer Email</Col>
            <Col xs={9} sm={9} md={9} lg={9}>: {trans.payor_email} </Col>
          </Row>
          <Row>
            <Col xs={3} sm={3} md={3} lg={3}>Buyer Contact</Col>
            <Col xs={9} sm={9} md={9} lg={9}>: {trans.payor_contact} ({trans.payor_contact_country})</Col>
          </Row>
          </React.Fragment>
        )
      this.setState({transDetails:transDetails,isTransLoading:false})

      var orderDetails = orders.map((order,index) => {
        return (
          <React.Fragment>
          <Row key={order.order_id}>
            <Col xs={12} sm={3} md={3} lg={3}>
              <Image src={order.small_image} responsive />
                {order.card_name}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4}>
                <FormGroup controlId="message" bsClass="card-textarea form-group">
                  <FormControl componentClass="textarea" rows={9} value={order.message} readOnly />
                </FormGroup>
            </Col>
            <Col xs={12} sm={5} md={5} lg={5}>
                <h3>To {order.name}</h3>
                <h4>Contact: {order.contact}</h4>
                <h4>{order.address}, <br/>{order.postcode} {order.city}, <br/>{order.state}</h4>
                {(order.quantity > 0 && order.order_type === 2) &&
                  <h4><b>(blank card x {order.quantity}, unit price: {order.price})</b></h4>
                }
            </Col>
          </Row>
          <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <br /><br />
          </Col>
          </Row>
          </React.Fragment>
        )
      })
      this.setState({orderDetails:orderDetails,isOrderLoading:false})
    })
    .catch (error => {

    })
  }

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}><h4>Transaction ID: {this.state.transId}</h4></Col>
        </Row>
        {this.state.isTransLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.transDetails}
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}><h4>Orders:</h4></Col>
        </Row>
        {this.state.isOrderLoading === true && (
          <div className="nl-loading"><img src={spinner} alt="spinner"/></div>
        )}
        {this.state.orderDetails}
      </Grid>
    )
  }
}

export default Transactions;
